import React, { useState, useEffect } from 'react';
import Connect from './Connect'
import Select from './Select'
import Answer from './Answer'
import Title from './Title';
import Openning from './Openning'
import Intro from './Intro'
import Button from './Button'
import Result from './Result'
import Guide from './Guide'
import Summary from './Summary';
import Data from './Data';
import Credit from './Credit';
import { ItemTypes } from './ItemTypes.js'
import GuideInterval from './GuideInterval';

const path = process.env.PUBLIC_URL

const quizData = [
  {
    type: "select",
    title: '两个恰恰好',
    performer: '演唱：旺福',
    choices: ["采花蜜", " ", "蜜蜂", "采花蜜", "", "飞到东", "飞到西", "", "如果", "你", " ", "四处", "采花蜜", "", "掐掐掐掐死", "你"],
    highlight: ["掐掐掐掐死", "你"],
    correctAnswer: "掐掐掐掐死",
    changedAnswer: "恰恰恰恰似",
    reason: "原词有“渲染暴力”、“凶杀”、恐吓之嫌，更可能“诱发社会犯罪”。《乐队的夏天》第一季的旺福乐队来自台湾，文字变了，但歌词的发音完全没变。"
  },
  {
    type: "select",
    title: '傲娇',
    performer: '演唱：郁可唯等',
    choices: ["女巫", "不发威", "你真", "当我", "病猫", "", "红颜祸水", " ", "算我", "头上", "就好", "", "忌妒", "是罪", " ", "巫术", "毒药", "收好", "", "过多", "自卑", " ", "收下", "就", "不用找"],
    highlight: ["忌妒是罪 ", "巫术", "毒药收好"],
    correctAnswer: "巫术",
    changedAnswer: "咒语",
    reason: "2015年发布的《电视剧内容制作通则》，明确指出“巫术”是封建迷信思想，电视剧中不能有。歌里有“巫术”可能也不行，《乘风破浪的姐姐》第一季就改唱“咒语”了。"
  },
  {
    type: "select",
    title: '地球仪',
    performer: '演唱：五条人',
    choices: ["在", "改革开放", "初期", "经商", "", "这样", "就可以", "为", "", "泰坦尼克号", "上的", "乘客", "", "做", "最后的", "表演"],
    highlight: ["在", "改革开放", "初期经商"],
    correctAnswer: "改革开放",
    changedAnswer: "八十年代",
    reason: "咱已经走上“新时代”的高速路，“旧时代”的改革开放不值一提，五条人在《乐夏》第二季改唱“八十年代”，成功复活。"
  },
  {
    type: "select",
    title: '生活因你而火热',
    performer: '演唱：新裤子',
    choices: ["没能", "继续", "的", "革命", "", "不欢而散", "的", "告别", "", "我", "倒下后", "", "不敢回头", "", "不能再见", "的", "朋友"],
    highlight: ["没能继续的", "革命"],
    correctAnswer: "革命",
    changedAnswer: "诗篇",
    reason: "上过网的都知道，“革命”是非常敏感的。新裤子在《乐夏》第一季放弃“革命”，重写“诗篇”。"
  },
  {
    type: "select",
    title: '现在不跳舞要干嘛',
    performer: '演唱：陈梓童等',
    choices: ["好啦", " ", "打几个", "饱嗝", " ", "预告", "今晚", "", "闷骚", "已久", "的", "筋骨", " ", "要解开", "", "现在", "不跳舞", "要干嘛", "", "微微的", "坏掉", " ", "都可以", "原谅"],
    highlight: ["闷骚", "已久的筋骨 要解开"],
    correctAnswer: "闷骚",
    changedAnswer: "蜷缩",
    reason: "第二季《乘风破浪的姐姐》中，“闷骚已久的筋骨”不可有，要改掉。"
  },
  {
    type: "select",
    title: '丽园便利店',
    performer: '演唱：和平和浪',
    choices: ["夜色", "照亮", "了", "丽园", "便利店", "", "没有", "游客", "也", "没人", "在", "打点", "", "门口", "有个", "少年", "在", "抽烟", "", "灯光", "烟雾", "看不清", "他的脸"],
    highlight: ["门口有个少年在", "抽烟"],
    correctAnswer: "抽烟",
    changedAnswer: "抽签",
    reason: "《电视剧内容制作通则》明确指出：“表现未成年人早恋、抽烟、酗酒、打架斗殴等不良行为”会对未成年人造成不良影响。所以在《乐夏》，摇滚乐队的烟掐掉了。"
  },
  {
    type: "select",
    title: '5:10a.m',
    performer: '演唱：傻子与白痴',
    choices: ["几分", "安然", "就", "几分", "贱", "", "无所事事", "的成为", "", "那", "差不多", "的谁", "", "不平庸", "也", "不特别"],
    highlight: ["几分安然就几分", "贱"],
    correctAnswer: "贱",
    changedAnswer: "艰",
    reason: "“贱”本义价格便宜、地位低下，此处是散布谣言，还是侮辱诽谤他人，还是危害社会公德？拿捏不准，只好宁改不留。好在《乐夏》第二季没把“傻子与白痴”改成“沙子与百尺”。"
  },
  {
    type: "connect",
    title: 'Where Are You Going?',
    performer: '演唱：海龟先生',
    choices: [
      { accept: ItemTypes.NA, content: "我们", lastDroppedItem: null },
      { accept: ItemTypes.NA, content: "宁愿", lastDroppedItem: null },
      { content: " " },
      { accept: ItemTypes.NA, content: "绝望", lastDroppedItem: null },
      { accept: ItemTypes.NA, content: "也", lastDroppedItem: null },
      { accept: ItemTypes.NA, content: "不信", lastDroppedItem: null },
      { content: "" },
      { accept: ItemTypes.NA, content: "自己", lastDroppedItem: null },
      { accept: ItemTypes.NA, content: "的", lastDroppedItem: null },
      { accept: ItemTypes.NA, content: "灵魂", lastDroppedItem: null },
      { content: " " },
      { accept: ItemTypes.NA, content: "没有", lastDroppedItem: null },
      { accept: ItemTypes.NA, content: "内在", lastDroppedItem: null },
      { accept: ItemTypes.NA, content: "的", lastDroppedItem: null },
      { accept: ItemTypes.NA, content: "美德", lastDroppedItem: null },
      { content: "" },
      { accept: ItemTypes.NA, content: "荣耀", lastDroppedItem: null },
      { accept: ItemTypes.NA, content: "的", lastDroppedItem: null },
      { accept: ItemTypes.A, content: "君王", lastDroppedItem: null },
      { content: " " },
      { accept: ItemTypes.NA, content: "被", lastDroppedItem: null },
      { accept: ItemTypes.B, content: "钉死", lastDroppedItem: null },
      { accept: ItemTypes.NA, content: "他乡", lastDroppedItem: null },
      { content: "" },
      { accept: ItemTypes.NA, content: "用", lastDroppedItem: null },
      { accept: ItemTypes.NA, content: "完全", lastDroppedItem: null },
      { accept: ItemTypes.NA, content: "的", lastDroppedItem: null },
      { accept: ItemTypes.NA, content: "义", lastDroppedItem: null },
      { content: " " },
      { accept: ItemTypes.NA, content: "担当", lastDroppedItem: null },
      { accept: ItemTypes.NA, content: "我们", lastDroppedItem: null },
      { accept: ItemTypes.NA, content: "的", lastDroppedItem: null },
      { accept: ItemTypes.NA, content: "苦难", lastDroppedItem: null },
      // { content: "" },
      // { accept: ItemTypes.NA, content: "这爱", lastDroppedItem: null },
      // { content: " " },
      // { accept: ItemTypes.NA, content: "已经", lastDroppedItem: null },
      // { accept: ItemTypes.NA, content: "来过", lastDroppedItem: null },
      // { accept: ItemTypes.NA, content: "这里", lastDroppedItem: null },
      // { content: "" },
      // { accept: ItemTypes.NA, content: "妈妈", lastDroppedItem: null },
      // { content: " " },
      // { accept: ItemTypes.NA, content: "我", lastDroppedItem: null },
      // { accept: ItemTypes.NA, content: "怎能", lastDroppedItem: null },
      // { accept: ItemTypes.NA, content: "轻看", lastDroppedItem: null },
      // { accept: ItemTypes.NA, content: "她的血", lastDroppedItem: null },
    ],
    highlight: ["荣耀的", "君王", " 被", "钉死", "他乡"],
    correctAnswer: ["君王", "钉死"],
    answers: [
      { index: 0, name: '主人', type: ItemTypes.A },
      { index: 1, name: '卖在', type: ItemTypes.B },
    ],
    reason: "海龟先生在《乐夏》的困境：荣耀的君王来自封建阶级，不合国情；钉死他吧，又涉嫌宣扬暴力、危害社会稳定。改成贩卖人口吧。"
  },
  {
    type: "connect",
    title: '玉',
    performer: '演唱：薛凯琪等',
    choices: [
      { accept: ItemTypes.NA, content: "想要", lastDroppedItem: null },
      { accept: ItemTypes.NA, content: "搞清", lastDroppedItem: null },
      { accept: ItemTypes.NA, content: "规则", lastDroppedItem: null },
      { content: "" },
      { accept: ItemTypes.NA, content: "却是", lastDroppedItem: null },
      { accept: ItemTypes.NA, content: "高清", lastDroppedItem: null },
      { accept: ItemTypes.NA, content: "灰色", lastDroppedItem: null },
      { content: "" },
      { accept: ItemTypes.NA, content: "许多", lastDroppedItem: null },
      { accept: ItemTypes.A, content: "腿", lastDroppedItem: null },
      { accept: ItemTypes.NA, content: "还", lastDroppedItem: null },
      { accept: ItemTypes.B, content: "跪着", lastDroppedItem: null },
      { content: "" },
      { accept: ItemTypes.NA, content: "脸上", lastDroppedItem: null },
      { accept: ItemTypes.NA, content: "露着", lastDroppedItem: null },
      { accept: ItemTypes.NA, content: "愧色", lastDroppedItem: null },      
    ],
    highlight: ["许多", "腿", "还", "跪着"],
    correctAnswer: ["腿", "跪着"],
    answers: [
      { index: 0, name: '人', type: ItemTypes.A },
      { index: 1, name: '睡着', type: ItemTypes.B },
    ],
    reason: "“许多腿还跪着”这种话，本来就可以有很多角度的联想。《乘风》的第三季改躺平了。"
  },
  {
    type: "connect",
    title: '在这里请你随意',
    performer: '演唱：那英等',
    choices: [
      { accept: ItemTypes.NA, content: "你可以", lastDroppedItem: null },
      { accept: ItemTypes.NA, content: "大笑", lastDroppedItem: null },
      { accept: ItemTypes.NA, content: "你可以", lastDroppedItem: null },
      { accept: ItemTypes.NA, content: "流泪", lastDroppedItem: null },
      { content: "" },
      { accept: ItemTypes.NA, content: "你可以", lastDroppedItem: null },
      { accept: ItemTypes.NA, content: "亲吻", lastDroppedItem: null },
      { accept: ItemTypes.NA, content: "你可以", lastDroppedItem: null },
      { accept: ItemTypes.A, content: "骂人", lastDroppedItem: null },
      { content: "" },
      { accept: ItemTypes.NA, content: "你可以", lastDroppedItem: null },
      { accept: ItemTypes.NA, content: "睡觉", lastDroppedItem: null },
      { accept: ItemTypes.NA, content: "你可以", lastDroppedItem: null },
      { accept: ItemTypes.B, content: "撒野", lastDroppedItem: null },
      { content: "" },
      { accept: ItemTypes.NA, content: "在这里", lastDroppedItem: null },
      { accept: ItemTypes.NA, content: "请你", lastDroppedItem: null },
      { accept: ItemTypes.NA, content: "随意", lastDroppedItem: null },
    ],
    highlight: ["你可以", "骂人", " 你可以", "撒野"],
    correctAnswer: ["骂人", "撒野"],
    answers: [
      { index: 0, name: '高冷', type: ItemTypes.A },
      { index: 1, name: '发泄', type: ItemTypes.B },
    ],
    reason: "“骂人”和“撒野”属于“使用粗俗的语言”，不可不可，既不符合《乘风》艺人们的形象，也不符合媒体“制作通则”。"
  }
];

const demo = [
  ["现在", "的", "一片", "天", "", "是", "肮脏", "的", "一片", "天"],
  [
    { accept: ItemTypes.NA, content: "Bye", lastDroppedItem: null },
    { content: " " },
    { accept: ItemTypes.NA, content: "Bye", lastDroppedItem: null },
    { content: " " },
    { accept: ItemTypes.NA, content: "主义", lastDroppedItem: null },
    { accept: ItemTypes.NA, content: "的", lastDroppedItem: null },
    { accept: ItemTypes.NA, content: "世界", lastDroppedItem: null },
  ],
  [
    { index: 0, name: '狭义', type: ItemTypes.A }
  ]
]

const Quiz = () => {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [currentStage, setCurrentStage] = useState('openning');
  const [currentStep, setCurrentStep] = useState('question');
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [score, setScore] = useState(0);

  const handleAnswer = (value) => {
    // Delay the state update by a few milliseconds
    setTimeout(() => {
      setSelectedAnswer(value);
    }, 100);
  }

  const submitAnswer = () => {
    if (selectedAnswer === quizData[currentQuestion].correctAnswer || selectedAnswer === true) {
      setScore(score + 1);
    }

    setCurrentStep('question');
    setSelectedAnswer(null);
    if (currentQuestion === 6) {
      setCurrentStep("internal")
    } else {
      setCurrentQuestion(currentQuestion + 1);
    }
  };

  useEffect(() => {
    const imgs = [
      path + "/images/cover.svg",
      path + "/images/banner.svg",
      path + "/images/title.svg",
      path + "/images/band.svg",
      path + "/images/bg.svg",
      path + "/images/bottom.svg",
      path + "/images/chop.svg",
      path + "/images/correct.svg",
      path + "/images/earser.svg",
      path + "/images/eye.svg",
      path + "/images/eye2.svg",
      path + "/images/flower.svg",
      path + "/images/head.svg",
      path + "/images/light.svg",
      path + "/images/pencil.svg",
      path + "/images/start.svg",
      path + "/images/sun.svg",
      path + "/images/wrong.svg",
    ]
    cacheImages(imgs);
  },[])

  const cacheImages = async (srcArray) => {
    const promises = await srcArray.map((src) => {
      const img = new Image();
      img.src = src;
    })
    await Promise.all(promises)
  }

  return (
    <>
      { currentStage === 'openning' ? (
        <>
          <Openning />
          <Button
            onClick={() => setCurrentStage('intro')}
            text="进入考场"
          />
        </>
      ) : currentStage === 'intro' ? (
        <>
          <Intro />
          <Button
            onClick={() => setCurrentStage('guide')}
            text="开考"
          />
        </>
      ) : currentStage === 'guide' ? (
        <>
          <Guide
            handleAnswer={handleAnswer}
            selectedAnswer={selectedAnswer}
            choices={demo[0]}
          />
          <Button
            onClick={() => {
              setCurrentStage('question');
              setSelectedAnswer(null);
            }}
            text="我学会啦"
          />
        </>
      ) : currentStage === 'question' ? (
        currentQuestion < quizData.length && currentStep === "question" ? (
          <>
            <Title title={quizData[currentQuestion].title} performer={quizData[currentQuestion].performer} />
            {quizData[currentQuestion].type === "select" ? (
              <Select
                handleAnswer={handleAnswer}
                selectedAnswer={selectedAnswer}
                choices={quizData[currentQuestion].choices}
              />
            ) : (
              <Connect
                handleAnswer={handleAnswer}
                scripts={quizData[currentQuestion].choices}
                word={quizData[currentQuestion].answers}
              />
            )}
            <Button
              onClick={() => setCurrentStep('answer')}
              disabled={selectedAnswer === null}
              text="提交答案"
            />
          </>
        ) : currentQuestion < quizData.length && currentStep === "answer" ? (
          <>
            <Answer
              selectedAnswer={selectedAnswer}
              correctAnswer={quizData[currentQuestion].correctAnswer}
              reason={quizData[currentQuestion].reason}
              highlight={quizData[currentQuestion].highlight}
              changedAnswer={quizData[currentQuestion].changedAnswer}
              answers={quizData[currentQuestion].answers}
            />
            <Button
              onClick={submitAnswer}
              text="下一题"
            />
          </>
        ) : currentQuestion < quizData.length && currentStep === "internal" ? (
          <>
            <GuideInterval
              handleAnswer={handleAnswer}
              answers={demo[2]}
              choices={demo[1]}
            />
            <Button
              onClick={() => {
                setCurrentStep("question");
                setCurrentQuestion(currentQuestion + 1);
                setSelectedAnswer(null);
              }}
              text="我学会啦"
            />
          </>
        ) : (
          <>
            <Result score={`${score}/${quizData.length}`} />
            <Button
              onClick={() => setCurrentStage('summary')}
              text="卷后总结"
            />
          </>
        )
      ) : currentStage === 'summary' ? (
        <>
          <Summary />
          <Button
            onClick={() => setCurrentStage('data')}
            text="数据分析"
            back={() => setCurrentStage('question')}
          />
          
        </>
      ) : currentStage === 'data' ? (
        <>
          <Data />
          <Button
            onClick={() => setCurrentStage('credit')}
            text="继续看看"
            back={() => setCurrentStage('summary')}
          />
        </>
      ): (
        <>
          <Credit />
          <Button
            onClick={() => {
              setCurrentStage('guide');
              setScore(0);
              setSelectedAnswer(null);
              setCurrentQuestion(0);
              setCurrentStep("question");
            }}
            text="重考"
            back={() => setCurrentStage('data')}
          />
        </>
      )}
    </>
  );
};

export default Quiz;
